<!--
* @description  参数1
* @fileName  byForm
* @author userName
* @date 2024-01-25 10:40:55
!-->
<template>
  <div id="byForm" class="byForm">
    <div class="main-info">
      <el-form
        ref="formData"
        :model="formData"
        :rules="allRules"
        label-position="top"
        size="medium"
        class="item-Surcharge"
        @submit.native.prevent
      >
        <div class="item-Surcharge_search">
          <el-form-item class="flex-width_1 w470" prop="companyName" label="公司名称" label-width="470px">
            <el-input v-model="formData.companyName" />
          </el-form-item>
          <el-form-item class="flex-width_1 w470" prop="name" label="联系人姓名" label-width="48%">
            <el-input v-model="formData.name" />
          </el-form-item>
          <el-form-item class="flex-width_1 w470" prop="email" label="电子邮箱" label-width="100%">
            <el-input v-model="formData.email" />
          </el-form-item>
          <el-form-item class="flex-width_1 w470" prop="tel" label="联系电话">
            <el-input v-model="formData.tel" />
          </el-form-item>
          <el-form-item class="flex-width_1 w100" prop="address" label="详细地址">
            <el-input v-model="formData.address" />
          </el-form-item>
          <el-form-item class="flex-width_1 w470" prop="cityName" label="城市">
            <el-input v-model="formData.cityName" :disabled="addrType==2||addrType==7" />
          </el-form-item>
          <el-form-item class="flex-width_1 w470" prop="provinceName" label="省/州(可选)">
            <el-input v-model="formData.provinceName" :disabled="addrType==2||addrType==7" />
          </el-form-item>
          <el-form-item class="flex-width_1 w470" prop="countryId" label="国家" label-width="48%">
            <el-select
              v-model="formData.countryId"
              popper-class="cargo_info_select"
              filterable
              placeholder="请选择国家"
              :disabled="addrType==2||addrType==7"
            >
              <el-option
                v-for="item in countryOptions"
                :key="item.id"
                :value="item.id"
                :label="item.nameEn+'-'+item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item class="flex-width_1 w470" prop="zipCode" label="邮编(可选)">
            <el-input v-model="formData.zipCode" :disabled="addrType==2||addrType==7" />
          </el-form-item>

        </div>
      </el-form>
      <div class="foot-button">
        <div v-if="formData.cusAddressId" class="remove" @click="remove">
          <i class="el-icon-delete" />
          <span>删除</span>
        </div>
        <button v-if="isDialog||isEdit" class="by-common--primary cancel" @click="clickCancel">取消</button>
        <button class="by-button--primary save" @click="clickSave">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DeleteCustomerAddress
} from '../../../../../../../api/user.js'
import {
  GetCountry
} from '../../../../../../../api/base.js'
import {
  CreateOrderAddress
} from '../../../../../../../api/order.js'
export default {
  name: 'ByForm',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
    buttonName: {
      type: String,
      default: () => {
        return '保存'
      }
    }
  },
  data() {
    return {
      formData: {
        companyName: '',
        name: '',
        email: '',
        tel: '',
        address: '',
        cityName: '',
        provinceName: '',
        countryId: '',
        zipCode: ''
      },
      allRules: {
        companyName: [{
          required: true,
          message: 'Required'
        }],
        name: [{
          required: true,
          message: 'Required'
        }],
        email: [{
          required: true,
          message: 'Required'
        }],
        tel: [{
          required: true,
          message: 'Required'
        }],
        address: [{
          required: true,
          message: 'Required'
        }],
        cityName: [{
          required: true,
          message: 'Required'
        }],
        countryId: [{
          required: true,
          message: 'Required'
        }]
      },
      countryOptions: [],
      orderData: {},
      addrType: undefined,
      isDialog: false,
      isEdit: false
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    GetCountry().then(res => {
      if (res.code === 200) {
        this.countryOptions = res.data
      }
    })
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data, addrType, formData, isDialog, isEdit) {
      console.log(JSON.stringify(data))
      this.orderData = data
      this.addrType = addrType
      this.isDialog = isDialog
      this.isEdit = isEdit
      if (formData) {
        this.formData = formData
      } else {
        if (addrType == 2) {
          this.formData.cityName = data.startCityNameEn
          this.formData.provinceName = data.startProvinceNameEn
          this.formData.countryId = data.startCountryId
          this.formData.zipCode = data.startCityZipcode
        } else if (addrType == 7) {
          this.formData.cityName = data.destCityNameEn
          this.formData.provinceName = data.destProvinceNameEn
          this.formData.countryId = data.destCountryId
          this.formData.zipCode = data.destZipCode
		 } else {
          this.resetForm()
        }
      }
    },
    resetForm() {
	  this.formData = {
	    companyName: '',
	    name: '',
	    email: '',
	    tel: '',
	    address: '',
	    cityName: '',
	    provinceName: '',
	    countryId: '',
	    zipCode: ''
	  }
    },
    remove() {
      this.$confirm('确定删除该地址吗?', '', {
		  confirmButtonText: '确定',
		  cancelButtonText: '取消',
		  type: 'warning'
      }).then(() => {
		  DeleteCustomerAddress(this.formData.cusAddressId).then(res => {
		    if (res.code === 200) {
		      this.$emit('save')
		    }
		  })
      })
    },
    // 方法
    clickCancel() {
      this.$emit('cencel')
    },
    clickSave() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.formData.orderNo = this.orderData.orderNo
          this.formData.addrType = this.addrType
          CreateOrderAddress(this.formData).then(res => {
            if (res.code === 200) {
              this.$emit('save')
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.item-Surcharge {
		width: 100%;
		background: #fff;
		border-radius: 8px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;

		.item-Surcharge_search {
			display: flex;
			margin-bottom: 16px;
			flex-wrap: wrap;
			width: auto;
			justify-content: space-between;

			.w470 {
				width: 48%; //470px;
			}

			.w100 {
				width: 100%;
			}

			.mr6 {
				margin-right: 6px;
			}

		}
	}

	.el-select {
		width: 100%;
	}

	::v-deep .el-form-item--medium {
		float: left;
		text-align: left;

		.el-form-item__label {
			line-height: 8px !important;
			padding: 0px 0px 7px 0 !important
		}

		.el-input {
			.el-input__inner {
				border-radius: 4px;
				border: 1px solid #dcdcdc;
				height: 40px;
				line-height: 32px;
				padding-left: 8px;
				font-size: 13px;
				font-family: "PingFangSC-Regular", "Microsoft YaHei", sans-serif;
				font-weight: 500;
				color: #333333;

				&:hover {
					border: 1px solid #999999;
				}

				&:focus {
					border: 1px solid #0046b9;
				}
			}
		}
	}

	.foot-button {
		display: flex;
		align-items: center;
		justify-content: end;
		padding-bottom: 24px;

		.remove {
			cursor: pointer;
			font-size: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #E90606;

			i {
				margin-right: 4px;
			}
		}

		.cancel {
			margin: 0 24px;
		}

		.cancel,
		.save {
			width: 120px;
			height: 40px;
		}

	}
</style>
